// @ts-nocheck
import React from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';
import LazyImage from 'crehana-ui/LazyImage';
import styled from 'styled-components';

interface MembershipFeature {
  id: number;
  title: string;
  description: string;
}

interface MembershipFeaturesSectionProps {
  features: Array<MembershipFeature>;
  imageUrl: string;
}

const StyledLazyImage = styled(LazyImage)`
  height: 302px;
  filter: drop-shadow(10px 21px 90px rgba(52, 23, 170, 0.4));
  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 505px;
  }
`;

const FeaturesSection: React.FC<MembershipFeaturesSectionProps> = ({
  features,
  imageUrl,
}) => {
  return (
    <section className="py-40 md:py-120 bg-base-dark">
      <Container>
        <Row className="justify-center md:items-center">
          <StyledLazyImage
            className="w-full sm:w-10/12 md:w-5/12 mb-80 md:mb-0"
            src={imageUrl}
            alt="art"
          />
          <Col sm={10} offset={{ md: 1 }} md={6}>
            <ul>
              {features.map((feature, index, arr) => (
                <li
                  key={feature.id}
                  className={index !== arr.length - 1 ? 'mb-40' : ''}
                >
                  <div>
                    <p className="font-h3 text-white mb-8">{feature.title}</p>
                    <p className="font-body3 text-gray-main">
                      {feature.description}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FeaturesSection;
